export const normalizeMdForCompare = (value: string): string =>
  value
    .replace(/\r\n/g, '\n')
    .replace(/[ \t]+$/gm, '')
    .replace(/\n+$/, '\n');

export const areMarkdownValuesEquivalent = (a: string, b: string): boolean =>
  normalizeMdForCompare(a) !== normalizeMdForCompare(b);

const MARKDOWN_ESCAPE_CHARS = new Set([
  '\\',
  '`',
  '*',
  '_',
  '{',
  '}',
  '[',
  ']',
  '(',
  ')',
  '#',
  '+',
  '-',
  '.',
  '!',
  '>',
]);

export const unescapeMarkdownOutput = (value: string): string =>
  value.replace(/\\(.)/g, (match, char) => (MARKDOWN_ESCAPE_CHARS.has(char) ? char : match));
